import type { ModuleMigrationDef } from "@kubdee/sdk";

export const migration: ModuleMigrationDef = {
  key: "006_stock_movement_controls",
  version: "1.0.0",
  sql: `
CREATE TABLE IF NOT EXISTS \`inventory_stock_transfers\` (
  \`id\` text PRIMARY KEY NOT NULL,
  \`company_id\` text NOT NULL,
  \`branch_id\` text,
  \`transfer_no\` text NOT NULL,
  \`from_warehouse_id\` text NOT NULL,
  \`to_warehouse_id\` text NOT NULL,
  \`posting_date\` text NOT NULL,
  \`remarks\` text,
  \`doc_status\` integer DEFAULT 0 NOT NULL,
  \`reference_module\` text,
  \`reference_id\` text,
  \`total_qty\` real DEFAULT 0 NOT NULL,
  \`total_amount\` real DEFAULT 0 NOT NULL,
  \`created_by\` text,
  \`created_at\` text NOT NULL,
  \`updated_by\` text,
  \`updated_at\` text,
  \`deleted_by\` text,
  \`deleted_at\` text
);
CREATE UNIQUE INDEX IF NOT EXISTS \`stock_transfers_transfer_no_unique\` ON \`inventory_stock_transfers\` (\`transfer_no\`);
CREATE INDEX IF NOT EXISTS \`st_company_date_idx\` ON \`inventory_stock_transfers\` (\`company_id\`,\`posting_date\`);
CREATE INDEX IF NOT EXISTS \`st_company_from_idx\` ON \`inventory_stock_transfers\` (\`company_id\`,\`from_warehouse_id\`);
CREATE INDEX IF NOT EXISTS \`st_company_to_idx\` ON \`inventory_stock_transfers\` (\`company_id\`,\`to_warehouse_id\`);

CREATE TABLE IF NOT EXISTS \`inventory_stock_transfer_items\` (
  \`id\` text PRIMARY KEY NOT NULL,
  \`stock_transfer_id\` text NOT NULL,
  \`item_id\` text NOT NULL,
  \`qty\` real DEFAULT 0 NOT NULL,
  \`rate\` real DEFAULT 0 NOT NULL,
  \`amount\` real DEFAULT 0 NOT NULL,
  \`remarks\` text,
  FOREIGN KEY (\`stock_transfer_id\`) REFERENCES \`inventory_stock_transfers\`(\`id\`) ON UPDATE no action ON DELETE no action
);
CREATE INDEX IF NOT EXISTS \`sti_transfer_idx\` ON \`inventory_stock_transfer_items\` (\`stock_transfer_id\`);
CREATE INDEX IF NOT EXISTS \`sti_item_idx\` ON \`inventory_stock_transfer_items\` (\`item_id\`);

CREATE TABLE IF NOT EXISTS \`inventory_stock_reservations\` (
  \`id\` text PRIMARY KEY NOT NULL,
  \`company_id\` text NOT NULL,
  \`item_id\` text NOT NULL,
  \`warehouse_id\` text NOT NULL,
  \`source_module\` text NOT NULL,
  \`source_doctype\` text NOT NULL,
  \`source_id\` text NOT NULL,
  \`source_line_id\` text,
  \`reserved_qty\` real DEFAULT 0 NOT NULL,
  \`status\` text DEFAULT 'active' NOT NULL,
  \`reservation_date\` text NOT NULL,
  \`expires_at\` text,
  \`created_by\` text,
  \`created_at\` text NOT NULL,
  \`updated_by\` text,
  \`updated_at\` text,
  \`deleted_by\` text,
  \`deleted_at\` text
);
CREATE INDEX IF NOT EXISTS \`sr_item_wh_idx\` ON \`inventory_stock_reservations\` (\`company_id\`,\`item_id\`,\`warehouse_id\`,\`status\`);
CREATE INDEX IF NOT EXISTS \`sr_source_idx\` ON \`inventory_stock_reservations\` (\`company_id\`,\`source_module\`,\`source_doctype\`,\`source_id\`);

CREATE TABLE IF NOT EXISTS \`inventory_stock_backorders\` (
  \`id\` text PRIMARY KEY NOT NULL,
  \`company_id\` text NOT NULL,
  \`item_id\` text NOT NULL,
  \`warehouse_id\` text NOT NULL,
  \`source_module\` text NOT NULL,
  \`source_doctype\` text NOT NULL,
  \`source_id\` text NOT NULL,
  \`source_line_id\` text,
  \`requested_qty\` real DEFAULT 0 NOT NULL,
  \`available_qty\` real DEFAULT 0 NOT NULL,
  \`backorder_qty\` real DEFAULT 0 NOT NULL,
  \`fulfilled_qty\` real DEFAULT 0 NOT NULL,
  \`status\` text DEFAULT 'open' NOT NULL,
  \`expected_date\` text,
  \`created_by\` text,
  \`created_at\` text NOT NULL,
  \`updated_by\` text,
  \`updated_at\` text,
  \`deleted_by\` text,
  \`deleted_at\` text
);
CREATE INDEX IF NOT EXISTS \`sb_item_wh_idx\` ON \`inventory_stock_backorders\` (\`company_id\`,\`item_id\`,\`warehouse_id\`,\`status\`);
CREATE INDEX IF NOT EXISTS \`sb_source_idx\` ON \`inventory_stock_backorders\` (\`company_id\`,\`source_module\`,\`source_doctype\`,\`source_id\`);
  `.trim(),
};
